/* eslint-disable no-use-before-define */
import React from 'react'
import { getId, Flyout } from '../../twd/twd'

export const Quantity = ({quantity, setQuantity, err, onEnter}) => {
    const id = getId()


    return <React.Fragment>
        <div className="vertical-offset-base">
        <div><Flyout
            label="Quantity"
            isLabel={true}
            labelAttrs={{htmlFor:id, className:'label'}}
            html={QuantityTooltip}
            labelStyle={{ lineHeight:'20px', display:'inline', flex:1, marginBottom:0 }}
        /></div>            

        <div className={err ? ' has-error' : ''}>
        <div className='vertical-offset-xxs'>
            <input 
                className="form-control"
                type="number"
                id={id}
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                onKeyUp={(e) => {
                    let key = e.keyCode || e.key || e.which
                    if (!(key===13 || key === 'Enter')) return

                    e.preventDefault()
                    onEnter()
                }}
            />
        </div>
        { err && <label className="field-status has-error">{err}</label> }
        </div>
        </div>
    </React.Fragment>
}


const QuantityTooltip = `
<p>Utilize the quantity field to input the number of bonds you wish to buy or sell in this hypothetical trade scenario.  You will find the available quantities associated with the current best bid and current best offer on the platform (when available) below the issuer name present at the top of this tool.<p>

<p>Please note:<br/>
Live markets may not be available to support orders for custom quantities which fall above or below the displayed dealer levels.</p>
`